import { ArrowClockwise, Info, Warning } from 'shared/icons';
import Button from './Button';

/**
 * Componente para exibir erros de forma amigavel
 */
const ErrorCard = ({
    title = 'Erro',
    message,
    action,
    actionFn,
    actionLink,
    type = 'error', // 'error', 'warning', 'info'
}) => {
    const icons = {
        error: Warning,
        warning: Warning,
        info: Info,
    };

    const Icon = icons[type] || Warning;

    const handleAction = () => {
        if (actionFn) {
            actionFn();
        } else if (actionLink) {
            window.location.href = actionLink;
        }
    };

    return (
        <div className="bg-white dark:bg-mono-950 border border-mono-200 dark:border-mono-800 rounded-xl shadow-mono dark:shadow-lg-mono p-8">
            <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
                <div className="mb-4 p-4 bg-mono-100 dark:bg-mono-900 rounded-full">
                    <Icon size={48} className="text-mono-700 dark:text-mono-300" />
                </div>

                <h2 className="text-2xl font-bold mb-3 text-black dark:text-white">{title}</h2>

                <p className="text-mono-600 dark:text-mono-400 mb-6 whitespace-pre-line">{message}</p>

                {action && (
                    <Button onClick={handleAction} className="min-w-[200px]">
                        {action === 'Tentar Novamente' && <ArrowClockwise size={20} className="mr-2" />}
                        {action}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ErrorCard;
